import React from 'react';
import { handleResponseLanguage } from '../../../../../../../i18n';

// Components
import CheckBox from './CheckBox';

// Types
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';

interface Props {
  question: FlowsQuestion;
}

const CheckBoxInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value, onBlur },
  } = useFlowInputComponent({
    question,
    defaultValue: false,
  });

  const handleChange = (value: boolean) => {
    onBlur({ name: question.id, value });
  };
  return (
    <CheckBox
      title={handleResponseLanguage(question.title)}
      description={handleResponseLanguage(question.description)}
      onChange={handleChange}
      value={value as boolean}
    />
  );
};
export default CheckBoxInputComponent;
